<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" :params="params" />
	<el-cascader
		v-else
		v-model="value"
		:disabled="disabled"
		:options="params"
		:props="props.props"
		clearable
		filterable
	/>
</template>

<script setup lang="ts">
	import { CascaderProps } from 'element-plus';
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: any;
		disabled?: boolean;
		params: any;
		props?: CascaderProps;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const emitPath = computed(() => !(props.props.emitPath === false));

	const value = computed({
		get() {
			// 多选，数据结构1/2/3,1/2/3 转为 [[1,2,3],[1,2,3]]
			if (props.props?.multiple) {
				return props.modelValue
					? props.modelValue.split(',').map((itm) => (emitPath.value ? itm.split('/') : itm))
					: [];
			}
			return props.modelValue ? (emitPath.value ? props.modelValue.split('/') : props.modelValue) : [];
		},
		set(val) {
			console.log(val);

			if (props.props?.multiple) {
				// 多选，数据结构[[1,2,3],[1,2,3]] 转为 1/2/3,1/2/3
				emit('update:modelValue', val ? val.map((itm) => (emitPath.value ? itm.join('/') : itm)).join(',') : '');
			} else {
				emit('update:modelValue', val ? (emitPath.value ? val.join('/') : val) : '');
			}
		},
	});
</script>

<style scoped></style>
